var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import getUserType from '../../utils/proxy-util/getUserType';
import isSns from '../../utils/proxy-util/isSns';
/**
 * 자동로그인 시 요청하여 얻은 응답결과를 TvingUser로 변환합니다.
 * @param appLoginBody
 */
var proxyAutoLogin = function (autoLoginBody) {
    var code = autoLoginBody.code, message = autoLoginBody.message, data = autoLoginBody.data;
    var custNo = data.custNo, userId = data.custId, tvingToken = data.tvingToken, authToken = data.authToken, userTypeValue = data.custType, lastPasswordUpdateDate = data.lastPasswordUpdateDate, cjOneMembershipYn = data.cjOneMembershipYn, realNameConfirmYn = data.realNameConfirmYn, email = data.email, accessToken = data.accessToken, refreshToken = data.refreshToken, regionCode = data.regionCode;
    var userNo = custNo === null || custNo === void 0 ? void 0 : custNo.toString();
    var userType = getUserType(userTypeValue, cjOneMembershipYn === 'Y');
    var _a = __read(email.split('@'), 2), emailAddress = _a[0], emailVendor = _a[1];
    return {
        userToken: tvingToken,
        authToken: authToken,
        accessToken: accessToken,
        refreshToken: refreshToken,
        userNo: userNo,
        userId: userId,
        isSns: isSns(userType),
        emailAddress: emailAddress,
        emailVendor: emailVendor,
        lastPasswordUpdateDate: lastPasswordUpdateDate,
        isRealNameConfirmed: realNameConfirmYn === 'Y',
        userType: userType,
        message: message,
        code: code,
        regionCode: regionCode,
    };
};
export default proxyAutoLogin;
